var exports = {
  "wQ": "SudoVerificationModal.module__passkeyVerifying___ci1KMU",
  "hU": "SudoVerificationModal.module__unavailable___ci1KMU",
  "TJ": "SudoVerificationModal.module__unavailableTitle___ci1KMU",
  "$r": "SudoVerificationModal.module__unavailableBody___ci1KMU",
  "zc": "SudoVerificationModal.module__formError___ci1KMU",
};

module.exports = exports;
